import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { closeUnderageModal } from '@/store/slices/modalSlice';
import useOutsideClick from '@/hooks/useOutsideClick';
import { Icons } from '@/utils/icons';
import useModalAnimation from '@/hooks/useModalAnimation';

const UnderageGamblingModal = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(
    (state) => state.modal.isUnderageModalOpen // <-- you will add this
  );

  const modalRef = useRef<HTMLDivElement>(null);
  const { animate, handleClose } = useModalAnimation({
    isOpen,
    onClose: () => dispatch(closeUnderageModal()),
  });

  useOutsideClick(modalRef, handleClose);

  if (!isOpen) return null;

  return createPortal(
    <div className="font-roboto fixed inset-0 z-[999] flex items-center justify-center bg-black/50 transition-opacity duration-300">
      <div
        ref={modalRef}
        className={`
          w-full max-w-[500px]
          bg-white
          shadow-xl
          overflow-hidden
          transform transition-all duration-300 ease-out
          text-primary-dark-grey
          ${animate ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0'}
        `}
      >
        {/* Header */}
        <div className="bg-primary flex justify-between items-center p-2">
          <h2 className="xl:font-medium xl:text-xl">18+(underage gambling)</h2>
          <button onClick={handleClose} className="hover:opacity-70 transition">
            <Icons.plusBold className="rotate-45 text-lg" />
          </button>
        </div>

        {/* Body */}
        <div className="p-2 text-sm leading-[22px] !font-normal">
          <p className="mb-4">Over 18s only</p>

          <p className="mb-4 leading-[22px]">
            It is an offence for anyone under the age of 18 to open an account or to gamble on our
            exchange. We take age-verification responsibilities very seriously. We carry out
            age-verification checks on all customers who use payment mechanisms which are available
            to under 18s and additionally perform random age-verification checks on customers using
            other forms of funding mechanisms. We may ask for information to verify your age and
            could restrict or suspend your account until your age is confirmed.
          </p>

          <p className="mb-4 uppercase leading-[22px]">
            Please note that anyone under the age of 18 years old found to be using this site will
            have any winnings forfeited and may also be reported to the police.
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default UnderageGamblingModal;
